import { useTranslation } from "react-i18next";
import defaultContent from "../../../../../../../content/profile";
import "./ABOProfilePinInfo.scss";
import PinInfo from "../../../../../PinInfo/PinInfo";

type Props = {
  currentPin: number;
  currentPinDate?: string;
  highestAwardAchieved: number;
  highestAwardAchievedDate?: string;
  highestTrackingAward: number;
  showHighestPin: boolean;
  isPlatinumOrAbove?: boolean;
  isEmeraldAndAbove?: boolean;
  isDiamondAndAbove?: boolean;
};
const ABOProfilePinInfo = (props: Props) => {
  const { t } = useTranslation(["profile"]);
  const {
    currentPin,
    currentPinDate,
    highestAwardAchieved,
    highestAwardAchievedDate,
    highestTrackingAward,
    showHighestPin,
    isPlatinumOrAbove,
    isEmeraldAndAbove,
    isDiamondAndAbove,
  } = props;
  const isAwardMasked = isPlatinumOrAbove || isEmeraldAndAbove || isDiamondAndAbove;

  if (isAwardMasked) return null;

  if (currentPin <= 0 && highestAwardAchieved <= 0 && highestTrackingAward <= 0) return <></>;

  return (
    <div className="abo-profile-pin-info">
      <h2 className="abo-profile-pin-info__header">{`${t(
        "aboProfile.overviewTab.pinInformation",
        defaultContent["aboProfile"]["overviewTab"]["pinInformation"],
      )}`}</h2>
      <div className="abo-profile-pin-info__content">
        <PinInfo title="currentPin" pinLevelCode={currentPin} date={currentPinDate} />
        <PinInfo
          title="highestPin"
          pinLevelCode={highestAwardAchieved}
          date={highestAwardAchievedDate}
          show={showHighestPin}
        />
        <PinInfo title="trackingPin" pinLevelCode={highestTrackingAward} />
      </div>
    </div>
  );
};

export default ABOProfilePinInfo;
